import styled from "styled-components";

/**
 * ♪ и 🔊 — настоящие кнопки (проба P50m20d, E6): обработчик стоял на значке ВНУТРИ блока, и `click()` по блоку
 * `[data-voicing=tts]` (скрипт, вспомогательные технологии) ничего не делал; с клавиатуры (Tab, Enter, Пробел) ♪ было
 * не нажать. Вид — как у прежнего блока: без рамки, фона и отступов кнопки.
 */
export const IconButtonSC = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  line-height: inherit;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;

  &:focus-visible {
    outline: 2px solid #1677ff;
    outline-offset: 2px;
    border-radius: 4px;
  }
`;
